import v2TestimonialSlider from './testimonials';

$(document).ready(() => {
  v2TestimonialSlider();
});
